// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"193854fe","453":"bfd56f49","958":"c27c44e2"}[chunkId] + ".chunk.js";
};